module.exports = __webpack_public_path__ + "img/quote.8472a3a5.png";